import { wait } from "../misc";
import type { Nullable } from "../types";

/**
 * This function is used to download a file from the browser.
 * @param file
 */
export async function download(file: Nullable<File>) {
	if (!file) return;
	const url = URL.createObjectURL(file);
	const a = document.createElement("a");
	a.href = url;
	a.download = file.name;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	URL.revokeObjectURL(url);
	await wait(350);
}
